"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var colors = __importStar(require("@material-ui/core/colors"));
var constants_1 = require("./constants");
var defaultTheme = (0, styles_1.createTheme)({
    palette: {
        primary: {
            main: colors.green[500],
            contrastText: colors.common.white
        },
        error: {
            main: colors.red[500],
            contrastText: colors.common.white
        }
    },
    overrides: {
        MuiButton: {
            label: {
                textTransform: 'none'
            }
        }
    },
    breakpoints: {
        values: {
            xs: constants_1.BREAKPOINTS.xs,
            sm: constants_1.BREAKPOINTS.sm,
            md: constants_1.BREAKPOINTS.md,
            lg: constants_1.BREAKPOINTS.lg,
            xl: constants_1.BREAKPOINTS.xl
        }
    }
});
exports.default = defaultTheme;
